import { mapActions } from "vuex";
import { showError } from "@/helpers/globalHelpers";
import moment from "moment";

export default {
    name: 'ActionPlanNotificationPendingTab',
    components: {
    },

    props:{
        allRequests:Boolean,
    },

    data() {
        return {
            isLoading: false,
            notificationPending: [],
            notificationPagination: null,
            notificationFilter: {
                type: 'CLIMA_LABORAL',
                status: 'PENDIENTE',
                page:1,
                limit: 20 || process.env.VUE_APP_PAGINATION_PER_PAGE,
                pagination: true,
            },
            headers: [
                { text: 'ID Plan de Acción', sortable: false, value: 'id_planaccion' },
                { text: 'Detalle de Plan de Acción', sortable: false, value: 'description' },
                { text: 'Solicitud', sortable: false, value: 'id' },
                { text: 'Fecha de creación de la solicitud', sortable: false, value: 'created_at' },
                { text: 'Periodo del Plan de Acción', sortable: false, value: 'evidence_updated_at' },
                { text: 'Usuario', sortable: false, value: 'user' },
                { text: "Acciones", value: "actions", sortable: false },
            ]
        };
    },

    computed: {
    },

    methods: {
        ...mapActions('action_plan', ['listActionPlanUpdatePagination']),

        async getNotificationPending() {
            this.isLoading = true;
            // if(this.allRequests) {
            //     this.notificationFilter.allRequests = this.allRequests;
            // }
            const { error, response } = await this.listActionPlanUpdatePagination(this.notificationFilter);
            if (error) showError(error);
            this.notificationPending = response.data;
            this.notificationPagination = response.pagination;
            this.isLoading = false;
        },

        formatDate(dateString) {

            if (!dateString) {
                return "-";
            }
            const dateOnly = moment.utc(dateString).format("DD/MM/YYYY");

            return dateOnly;
        },

        formatStringDate(dateString) {
            if (!dateString) return "-";
            return moment(dateString, "YYYY-MM-DD").format("DD/MM/YYYY");
        },


        setApprovers(item) {
            if (!item.modification_histories || item.modification_histories.length === 0) {
                return '';
            }

            const approvers = item.modification_histories[0]?.approvers;

            if (!approvers || approvers.length === 0) {
                return '';
            }

            const ids = approvers.map(approver => approver.response_user.fullName);

            return ids.length > 1 ? ids.join(' - ') : ids[0].toString();
        }
    },

    created() {
        this.getNotificationPending();
    },

    mounted() {
    },

    beforeDestroy() {
    },
};